import { useState,useMemo,useEffect, useCallback } from 'react';
import {Modal,Input} from 'antd';
import { cdnUrl } from '@/utils/cdn';
import { CHAIN_CONFIG } from './config';
import { useTranslation } from 'react-i18next';
import { useSelector,useDispatch } from 'react-redux';
import { setChainModalOpen } from '@/stores/reducers/common';
import { THEME } from '@/config';
import './index.less';

const DEFAULT_CHAIN = THEME;
export default function Chain(){
  const { t,i18n } = useTranslation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const chainModal = useSelector((state: { common: { chainModal:any } }) => state.common.chainModal);
  // console.log("routeParams",routeParams)
  const [searchValue, setSearchValue] = useState('');

  const currentChain = useMemo(()=>{
    return CHAIN_CONFIG.find((item: { key: string; icon?: string; name?: string }) => item.key === DEFAULT_CHAIN)
  },[DEFAULT_CHAIN]);
  // console.log("currentChain",currentChain);

  const isHotList = useMemo(()=>{
    let sortList = ['solana', 'bsc', 'base', 'ethereum', 'xlayer'];
    return CHAIN_CONFIG
      .filter((item)=>item.isHot)
      .sort((a, b) => {
        const indexA = sortList.indexOf(a.key);
        const indexB = sortList.indexOf(b.key);
        // 如果两个都在 sortList 中，按索引排序
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        // 如果只有 a 在 sortList 中，a 排在前面
        if (indexA !== -1) {
          return -1;
        }
        // 如果只有 b 在 sortList 中，b 排在前面
        if (indexB !== -1) {
          return 1;
        }
        // 如果都不在 sortList 中，保持原顺序
        return 0;
      });
  },[chainModal]);

  //优先标注热门公链，已存在时，其他的不标注
  const isExist = useMemo(()=>{
    return !!isHotList.find((item)=>{
      return item.key === currentChain?.key;
    });
  },[isHotList,currentChain?.key])

  const isOtherList = useMemo(()=>{
    return CHAIN_CONFIG.sort((a,b)=>a.name?.localeCompare(b.name || ""));
  },[chainModal]);

  const filteredList = useMemo(()=>{
    return CHAIN_CONFIG.filter((item)=>{
      return item.name?.toLowerCase().indexOf(searchValue?.toLowerCase()) !== -1 
    }).sort((a,b)=>a.name?.localeCompare(b.name || ""));
  },[searchValue]);

  useEffect(()=>{
    setOpen(chainModal?.visible || false);
  },[chainModal?.visible]);

  const onCancel = () => {
    dispatch(setChainModalOpen({type: "", visible: false}));
  }

  const onChangeChain = useCallback((item: { key: string; icon?: string; name?: string; deployUrl?: string }) => {
    // console.log(item)
    // 如果存在部署域名，则外链访问
    if(item?.deployUrl){
      window.open(`${item?.deployUrl.replace("{{lang}}", i18n.language || "en-us")}`, '_blank');
      return 
    }
  },[i18n.language])

  // 高亮匹配文本的函数
  const highlightText = useCallback((text: string, searchValue: string) => {
    if (!searchValue || !text) {
      return text;
    }
    const escapedSearch = searchValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearch})`, 'gi');
    const parts = text.split(regex);
    const testRegex = new RegExp(`^${escapedSearch}$`, 'i');
    return parts.map((part, index) => {
      // split 使用捕获组时，匹配的部分会保留在数组中
      if (testRegex.test(part)) {
        return <span key={index} className="highlight">{part}</span>;
      }
      return part;
    });
  }, []);

  const ListView = useCallback(({item, isExist = false}: {
    item: { key: string; icon?: string; name?: string }; isExist?: boolean
  }) => {
    return (<li key={item?.key} className={!isExist &&item?.key === currentChain?.key ? "active" : ""} onClick={() => onChangeChain(item)}>
      <img src={cdnUrl(item?.icon || "")} alt={item?.name || ""} />
      <span className="name">
        {searchValue ? highlightText(item?.name || "", searchValue) : item?.name || ""}
      </span>
    </li>)
  },[currentChain?.key, onChangeChain, highlightText,searchValue])

  return <Modal
    title={t("chainModal.title")}
    open={open}
    centered
    width={560}
    onCancel={onCancel}
    footer={null}
    rootClassName={`custom-modal-root chain-modal-root`}
  >
    <div className="chain-modal-content">
      <Input 
      prefix={<img src={cdnUrl("/img/search.svg")} alt="search" />} 
      placeholder={t("chainModal.searchPlaceholder")}
      allowClear
      value={searchValue}
      onChange={(e)=>setSearchValue(e.target.value)}
      />
      {
        searchValue.length > 0 ? (
          filteredList.length > 0 ? (<div className="content-section">
          <p className="title">{t("chainModal.searchResult")}</p>
          <ul className="item-list">
            {
              filteredList.map((item)=>{
                return (<ListView key={item.key} item={item}/>)
              })
            }
          </ul>
        </div>):<div className="empty-content-section">
          <img src={cdnUrl("/img/empty1.svg")} alt="" />
          <p className="title">{t("chainModal.noSearchResult")}</p>
        </div>)
        :<>
          {
          isHotList.length > 0 && (<div className="content-section">
            <p className="title">🔥{t("chainModal.hotChain")}</p>
            <ul className="item-list">
              {
                isHotList.map((item)=>{
                  return (<ListView key={item.key} item={item} />)
                })
              }
            </ul>
          </div>)
        }
        {
          isOtherList.length > 0 && ( <div className="content-section">
            <p className="title">{t("chainModal.allChain")}</p>
            <ul className="item-list">
              {
                isOtherList.map((item)=>{
                  return (<ListView key={item.key} item={item} isExist={isExist}/>)
                })
              }
            </ul>
          </div>)
        }
        </>
      }
    </div>
  </Modal>
}